import app from '@/app';
import templateUrl from './auditLog-search.html';

/* @ngInject */
function AuditLogSearchController($controller, $state, DialogService, AuditLog, $http, Principal, $translate) {
	var $ctrl = this;
	var resource = AuditLog;

	// The audit "module" is stored inconsistently (entity class names, enum titles,
	// even already-translated labels). Translate name.<module> when a key exists;
	// otherwise fall back to the stored value so it never shows a raw "name.X".
	// "measurement" and "measurements" are legacy/ambiguous generic codes: "measurement"
	// was used by every survey type before per-type audit logging existed, and
	// "measurements" is still written today by the survey Excel import (DataResource)
	// but was also used, in an even older version, by survey query/delete actions.
	// "name.measurement"/"name.measurements" are ambiguous once shown next to the
	// per-type "measurements.<type>" labels, so route these to dedicated keys.
	var MODULE_LABEL_KEYS = {
		measurement: 'auditLog.module.measurement',
		measurements: 'auditLog.module.measurementsImport',
		roadGeometryImport: 'auditLog.module.roadGeometryImport'
	};

	$ctrl.moduleLabel = module => {
		if (!module) {
			return '';
		}
		var key =
			MODULE_LABEL_KEYS[module] ||
			(module.indexOf('measurements.') === 0 ? 'auditLog.module.' + module : 'name.' + module);
		var label = $translate.instant(key);
		return label === key ? module : label;
	};

	$ctrl.currentAccount = null;

	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});

	$controller('AbstractPageSortController', { $ctrl: $ctrl });

	$ctrl.startDatePickerOpen = false;
	$ctrl.endDatePickerOpen = false;

	$ctrl.dateOptions = {
		formatYear: 'yyyy',
		startingDay: 1,
		showWeeks: false
	};

	$ctrl.startDate = $ctrl.startDate || null;
	$ctrl.endDate = $ctrl.endDate || null;

	var transition = $ctrl.transition;

	$ctrl.transition = params => {
		transition(params);
		$ctrl.userName = params.userName;
		$ctrl.module = params.module;
		$ctrl.operation = params.operation;
		$ctrl.startDate = params.startDate ? new Date(params.startDate) : null;
		$ctrl.endDate = params.endDate ? new Date(params.endDate) : null;
		resource.query(
			{
				userName: params.userName,
				module: params.module,
				operation: params.operation,
				startDate: params.startDate,
				endDate: params.endDate,
				sort: params.sort,
				page: $ctrl.page,
				size: $ctrl.size
			},
			data => {
				$ctrl.entities = data.content;
				$ctrl.count = data.totalElements;
			}
		);
	};


	$ctrl.onQueryChange = () => {
		$state.go(
			$state.current,
			{
				page: 0,
				userName: $ctrl.userName ? $ctrl.userName : null,
				module: $ctrl.module ? $ctrl.module : null,
				operation: $ctrl.operation ? $ctrl.operation : null,
				startDate: $ctrl.startDate ? $ctrl.startDate.toISOString() : null,
				endDate: $ctrl.endDate ? $ctrl.endDate.toISOString() : null
			},
			{
				reload: true
			}
		);
	};

	$ctrl.exportLinkFullLogs = '/api/auditLogs/excel';

}

app.component('auditLogSearch', {
	templateUrl,
	controller: AuditLogSearchController,
	bindings: {
		$transition$: '<'
	}
});
